import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLens = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 32,
	viewBox: "0 0 28 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8333 25.5393C17.988 25.5393 22.1667 20.913 22.1667 15.206C22.1667 9.49907 17.988 4.87268 12.8333 4.87268C7.67868 4.87268 3.5 9.49907 3.5 15.206C3.5 20.913 7.67868 25.5393 12.8333 25.5393Z",
			stroke: "white",
			strokeWidth: 1.62882,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.4969 28.1225L19.4219 22.5038",
			stroke: "white",
			strokeWidth: 1.62882,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgLens);
export { ForwardRef as ReactComponent };
